import React from 'react';
import c from 'classnames';

export default function IconGoogle(props: { className?: string }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1024 1024"
            xmlSpace="preserve"
            className={c('fill-current', props.className)}
        >
            <path d="M512 469.333333h364.074667c1.877333 16.426667 2.858667 33.28 2.858666 50.517334 0 116.650667-41.813333 214.869333-114.261333 281.6-63.36 58.496-150.101333 92.8-253.525333 92.8A382.976 382.976 0 0 1 128 511.146667 382.976 382.976 0 0 1 511.146667 128c103.253333 0 189.994667 37.973333 256.341333 99.797333L705.109333 290.133333C655.701333 242.389333 588.928 213.333333 512 213.333333a298.666667 298.666667 0 1 0 0 597.333334c150.442667 0 262.144-111.274667 280.618667-256H512v-85.333334z" />
        </svg>
    );
}
